export const SERVICE_COLORS = [
  { bgHex: '#dbeafe', borderHex: '#3b82f6', textHex: '#1e40af', dotHex: '#3b82f6', monthHex: '#3b6cf4' }, // blue
  { bgHex: '#ede9fe', borderHex: '#7c3aed', textHex: '#5b21b6', dotHex: '#7c3aed', monthHex: '#7c3aed' }, // violet
  { bgHex: '#d1fae5', borderHex: '#059669', textHex: '#065f46', dotHex: '#059669', monthHex: '#059669' }, // emerald
  { bgHex: '#fef3c7', borderHex: '#d97706', textHex: '#92400e', dotHex: '#d97706', monthHex: '#d97706' }, // amber
  { bgHex: '#ffe4e6', borderHex: '#e11d48', textHex: '#9f1239', dotHex: '#e11d48', monthHex: '#e11d48' }, // rose
  { bgHex: '#cffafe', borderHex: '#0891b2', textHex: '#164e63', dotHex: '#0891b2', monthHex: '#0891b2' }, // cyan
  { bgHex: '#ffedd5', borderHex: '#ea580c', textHex: '#7c2d12', dotHex: '#ea580c', monthHex: '#ea580c' }, // orange
];

export const NO_SERVICE_COLOR = { 
  bgHex: '#f1f5f9', 
  borderHex: '#94a3b8', 
  textHex: '#475569', 
  dotHex: '#94a3b8', 
  monthHex: '#94a3b8' 
};
